module.exports = __webpack_public_path__ + "img/undraw_Done_checking_re_6vyx.97aa0d38.svg";